/*
 * Zentrale sprachunabhängige Help-Ziele für betty.
 *
 * Die eigentlichen Texte liegen in:
 *   src/help/de/
 *   src/help/en/
 *
 * Kurze UI-Texte und Tooltips liegen in:
 *   src/i18n/de/help.json
 *   src/i18n/en/help.json
 *
 * Diese Datei enthält ausschließlich Navigation und Beziehungen.
 */

export const helpTargets = {
  glossary: {
    article: "glossary",
  },

  evaluation: {
    article: "evaluate",
    related: [
      "teamStrengths",
      "expectedTable",
      "shouldTable",
    ],
  },

  goalExpectancy: {
    article: "glossary",
    anchor: {
      de: "torerwartung",
      en: "goal-expectancy",
    },
    related: [
      "expectedGoals",
      "expectedTable",
      "fairOdds",
    ],
  },

  expectedGoals: {
    article: "expected-goals",
    related: [
      "goalExpectancy",
      "teamStrengths",
      "seasonParameters",
      "shouldGoals",
      "expectedTable",
      "actualTable",
      "closedModel",
    ],
  },

  shouldGoals: {
    article: "should-goals",
    related: [
      "shouldTable",
      "expectedGoals",
      "statisticWeight",
      "attackMoments",
      "conversionRate",
      "standardConversionRate",
    ],
  },

  actualTable: {
    article: "actual-table",
    related: [
      "expectedTable",
      "shouldTable",
      "tableComparison",
    ],
  },

  expectedTable: {
    article: "expected-table",
    related: [
      "actualTable",
      "shouldTable",
      "expectedGoals",
      "goalExpectancy",
      "tableComparison",
    ],
  },

  shouldTable: {
    article: "should-table",
    related: [
      "actualTable",
      "expectedTable",
      "shouldGoals",
      "tableComparison",
    ],
  },

  tableComparison: {
    article: "expected-vs-actual",
    related: [
      "actualTable",
      "expectedTable",
      "shouldTable",
    ],
  },

  tableStats: {
    article: "table-stats",
    related: [
      "expectedTable",
      "actualTable",
      "shouldTable",
      "averageExpectedProbability",
      "averageOccurredProbability",
      "averageExpectedGoalDeviation",
      "averageOccurredGoalDeviation",
    ],
  },

  fairOdds: {
    article: "fair-odds",
    related: [
      "goalExpectancy",
      "value",
      "marketOddsAndValue",
    ],
  },

  value: {
    article: "value",
    related: [
      "fairOdds",
      "marketOddsAndValue",
    ],
  },

  marketOddsAndValue: {
    article: "market-odds-and-value",
    related: [
      "fairOdds",
      "value",
    ],
  },

  teamStrengths: {
    article: "team-strengths",
    related: [
      "teamSettings",
      "evaluation",
      "seasonParameters",
      "expectedGoals",
      "goalRatio",
      "goalLevel",
      "closedModel",
    ],
  },

  teamSettings: {
    article: "team-settings",
    related: [
      "teamStrengths",
      "seasonParameters",
    ],
  },

  seasonParameters: {
    article: "season-parameters",
    related: [
      "teamStrengths",
      "homeAdvantage",
      "goalAverage",
      "expectedGoals",
      "evaluation",
      "closedModel",
    ],
  },

  homeAdvantage: {
    article: "home-advantage",
    related: [
      "seasonParameters",
      "teamStrengths",
    ],
  },


  drawFactor: {
    article: "season-parameters",
    related: [
      "seasonParameters",
      "teamStrengths",
      "tableStats",
    ],
  },


  closedModel: {
    article: "closed-model",
    related: [
      "teamStrengths",
      "seasonParameters",
      "expectedGoals",
    ],
  },

  goalRatio: {
    article: "goal-ratio",
    related: [
      "teamStrengths",
      "goalLevel",
    ],
  },

  goalLevel: {
    article: "goal-level",
    related: [
      "teamStrengths",
      "goalRatio",
      "goalAverage",
    ],
  },

  goalAverage: {
    article: "goal-average",
    related: [
      "seasonParameters",
      "homeAdvantage",
      "goalLevel",
    ],
  },

  averageExpectedProbability: {
    article: "table-stats",
    related: [
      "averageOccurredProbability",
      "tableStats",
      "evaluation",
    ],
  },

  averageOccurredProbability: {
    article: "table-stats",
    related: [
      "averageExpectedProbability",
      "tableStats",
      "evaluation",
    ],
  },

  averageExpectedGoalDeviation: {
    article: "table-stats",
    related: [
      "averageOccurredGoalDeviation",
      "tableStats",
      "goalExpectancy",
    ],
  },

  averageOccurredGoalDeviation: {
    article: "table-stats",
    related: [
      "averageExpectedGoalDeviation",
      "tableStats",
      "goalExpectancy",
    ],
  },

  statisticWeight: {
    article: "statistic-weight",
    related: [
      "attackMoments",
      "shouldGoals",
      "conversionRate",
    ],
  },

  attackMoments: {
    article: "attack-moments",
    related: [
      "statisticWeight",
      "conversionRate",
      "shouldGoals",
    ],
  },

  conversionRate: {
    article: "conversion-rate",
    related: [
      "standardConversionRate",
      "attackMoments",
      "shouldGoals",
    ],
  },

  standardConversionRate: {
    article: "standard-conversion-rate",
    related: [
      "conversionRate",
      "attackMoments",
      "shouldGoals",
    ],
  },

  compilation: {
    article: "compile",
    related: [
      "evaluation",
      "fairOdds",
      "value",
    ],
  },

  simulation: {
    article: "simulation",
    related: [
      "fairOdds",
      "value",
    ],
  },
};

export function getHelpTarget(key) {
  return helpTargets[key] || null;
}
